import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  RdsBadgeDirective,
  RdsHeaderLinkComponent,
  RdsIconComponent,
} from '@rds/angular-components';

import { FavoriteService } from '@bookly-user/rooms/services/favorite.service';

@Component({
  selector: 'bus-favorite-indicator',
  imports: [
    RdsBadgeDirective,
    RdsIconComponent,
    RouterLink,
    RouterLinkActive,
    RdsHeaderLinkComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './favorite-indicator.component.html',
})
export class FavoriteIndicatorComponent implements OnInit {
  readonly #favoriteService = inject(FavoriteService);

  readonly favoriteCount = this.#favoriteService.favoriteCount;

  ngOnInit() {
    this.#favoriteService.initializeCount().subscribe();
  }
}
